import React, { useState, useEffect } from 'react'
import Navigation from '../components/Navigation'
import HeroSection from '../components/HeroSection'
import ProblemSection from '../components/ProblemSection'
import HowItWorksSection from '../components/HowItWorksSection'
import SolutionSection from '../components/SolutionSection'
import DashboardCarousel from '../components/DashboardCarousel'
import FeaturesSection from '../components/FeaturesSection'
import UseCasesSection from '../components/UseCasesSection'
import SocialProofSection from '../components/SocialProofSection'
import MultiLocationSection from '../components/MultiLocationSection'
import PricingSection from '../components/PricingSection'
import GuaranteeSection from '../components/GuaranteeSection'
import FAQSection from '../components/FAQSection'
import CTASection from '../components/CTASection'
import AboutSection from '../components/AboutSection'
import Footer from '../components/Footer'

const LandingPage = () => {
  const [isNavSticky, setIsNavSticky] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsNavSticky(window.scrollY > 0)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="min-h-screen bg-white">
      <Navigation isSticky={isNavSticky} />
      <HeroSection />
      <ProblemSection />
      <HowItWorksSection />
      <SolutionSection />
      <DashboardCarousel />
      <FeaturesSection />
      <UseCasesSection />
      <SocialProofSection />
      <MultiLocationSection />
      <PricingSection />
      <GuaranteeSection />
      <FAQSection />
      <CTASection />
      <AboutSection />
      <Footer />
    </div>
  )
}

export default LandingPage
